import React from 'react';
import { useAuth } from '../hooks/useAuth.js';
export const GuardedAction = ({ children, onSuccess, onFailure }) => {
    const { user, isLoading } = useAuth();
    const handleClick = (e) => {
        // 阻止任何由子组件（如 a 标签）发起的默认事件
        e.preventDefault();
        // 如果正在加载认证状态，则不执行任何操作
        if (isLoading) {
            return;
        }
        if (user) {
            onSuccess();
        }
        else {
            // 如果用户未登录，调用 onFailure 回调
            onFailure?.();
        }
    };
    // 克隆 children 元素并注入新的 onClick 处理器
    return React.cloneElement(children, {
        onClick: handleClick,
    });
};
//# sourceMappingURL=GuardedAction.js.map